import React from 'react';

import { Button, Stack, Text, Title } from '@mantine/core';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { preserveQueryParams } from 'utils/navigation';

// The billing-plan-disabled error screen (spec Item 4). Rendered at every entry
// point into a disabled plan: page load, the catalog's "Unavailable" CTA, and the
// mid-checkout fail-forward when the plan is disabled while a buyer is inside the
// accordion. Standalone by design — no CheckoutContext, so the page can render it
// before the checkout mounts.
const BillingPlanError = (): JSX.Element => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { salesPortalSlug } = useParams<{ salesPortalSlug: string }>();

  const handleBackToPackages = (): void => {
    navigate(preserveQueryParams(`/sales-portal/${salesPortalSlug}`, searchParams));
  };

  return (
    <Stack spacing='lg' align='center' p='xl' data-cy='billingPlanErrorScreen'>
      <Title order={2} align='center' fw={700}>
        This package isn&apos;t available for purchase right now
      </Title>

      <Text c='dimmed' size='sm' align='center' maw={500}>
        The gym is still setting up this offer. Contact them directly to complete your signup.
      </Text>

      <Button size='lg' onClick={handleBackToPackages} mt='md' data-cy='billingPlanErrorBackToPackages'>
        Back to packages
      </Button>
    </Stack>
  );
};

export default BillingPlanError;
